import React, { useEffect, useRef } from 'react';
import { useSdkState } from '@atlassian/commerce-experience-sdk-react/platform';
import { CreditCardFormBreadcrumb, useErrorBoundaryEventDispatch } from '../../common/utils/events';
import { FormStartTimeRecorder } from '../../common/utils/start-time';
import { useCreditCardState } from '../../controllers/hooks/use-credit-card-state';
import { useElementsAreReady, useElementsDidFail } from '../../controllers/hooks/use-elements-state';
import { Form } from './edit';
import { ErrorCreditCard } from './error';
import { FrameBreaker } from './frame-breaker';
import { LoadingCreditCard } from './loading';
import { FormSection } from './styled';
/**
 * Renders a CreditCard form
 * Has to be wrapped with {@link CreditCardFormState}
 * @test-id commerce-creditcard.{'loading' | 'error' | 'complete'}-state
 */
export var CreditCardForm = function CreditCardForm(_ref) {
  var className = _ref.className,
    autoFocus = _ref.autoFocus,
    onStateChange = _ref.onStateChange,
    _ref$frameEmbeddingMi = _ref.frameEmbeddingMitigation,
    frameEmbeddingMitigation = _ref$frameEmbeddingMi === void 0 ? true : _ref$frameEmbeddingMi;
  var state = useCreditCardState();
  var elementsReady = useElementsAreReady();
  var elementsFailed = useElementsDidFail();
  var isInSDK = useSdkState();
  var isLoading = state === 'loading' || !elementsReady;
  var isError = state === 'error' || elementsFailed;
  var errorBoundaryEventDispatch = useErrorBoundaryEventDispatch();
  var didErrorRef = useRef(isError);
  didErrorRef.current = didErrorRef.current || isError;
  var didError = didErrorRef.current;
  useEffect(function () {
    if (didError) {
      // TODO: Get the real error
      errorBoundaryEventDispatch(new Error('An error was caught by the error boundary'));
    }
  }, [errorBoundaryEventDispatch, didError]);

  // TODO: Better state composition
  var displayState = state === 'complete' && isLoading ? 'loading' : state;
  useEffect(function () {
    onStateChange && onStateChange(displayState);
  }, [displayState, onStateChange]);
  return /*#__PURE__*/React.createElement(FrameBreaker, {
    disabled: isInSDK || !frameEmbeddingMitigation
  }, /*#__PURE__*/React.createElement(FormStartTimeRecorder, null), /*#__PURE__*/React.createElement(FormSection, {
    "data-testid": "commerce-creditcard.".concat(displayState, "-state")
  }, didError ? /*#__PURE__*/React.createElement(ErrorCreditCard, null) : /*#__PURE__*/React.createElement(CreditCardFormBreadcrumb, null, /*#__PURE__*/React.createElement(Form, {
    className: className,
    autoFocus: autoFocus
  }), /*#__PURE__*/React.createElement(LoadingCreditCard, {
    visible: isLoading
  }))));
};